<ion-item-group [ngClass]="hostClassString">
  <ng-content></ng-content>
</ion-item-group>
